import { Component, NgModule, OnInit, ViewChild } from '@angular/core';
import { IGlobalEmployeeInfoModel } from '../../../entities-api/IGlobalEmployeeInfoModel';
import { IGlobalEmployeeDetailGridDataModel } from '../../../entities-api/IGlobalEmployeeDetailGridDataModel';
import { PageService } from '../../../services/page.service';
import { GridTypeEnum } from '../../../constants/grid-type.enum';
import { GridResultEnum } from '../../../constants/grid-result.enum';
import { HttpClient } from '@angular/common/http';
import { GridResultService } from '../../../services/gridresult.service';
import { Constants } from '../../../constants/constants';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { NgSelectComponent } from '@ng-select/ng-select';
import { IMfModel } from '../../../entities-api/IMfModel';
import { IBaseMappingFetchCriteriaModel } from '../../../entities-api/IBaseMappingFetchCriteriaModel';
import { Router } from '@angular/router';
import { IBaseMappingDetailGridDataModel } from '../../../entities-api/IBaseMappingDetailGridDataModel';
import { ContainermappingService } from '../../../services/containermapping.service';
import { ExportExcelService } from '../../../services/export-excel-service';



@Component({
  selector: 'app-opm-basemappings',
  templateUrl: './opm-basemappings.component.html',
  styleUrls: ['./opm-basemappings.component.less'],
  standalone: false
})

export class OpmBasemappingsComponent implements OnInit {
  @ViewChild('ngselectmf') ngselectmf: NgSelectComponent;

  constructor(
    protected http: HttpClient,
    private gridtype: GridResultService,
    private page: PageService,
    private router: Router,
    private containermappingService: ContainermappingService,
    private exportExcelService: ExportExcelService) {

  }
  name = 'Angular';
  isLoaded = false;
  isLoadedmf = true;
  geocode = [];
  mfcode = [];
  mfcodeobs: Observable<any[]>;
  gridDataModel: IBaseMappingDetailGridDataModel;
  gridTypeEnum = GridTypeEnum;
  gridResult: string;
  gridResultEnum = GridResultEnum;
  selectedgeo;
  selectedmf = [];
  geoname = [];
  mfname = [];
  currentPage: number;
  filter: IBaseMappingFetchCriteriaModel = this.containermappingService.filterbasemapping;
  noMatchesFoundMsg: string = "No matches Found";
  isUserAuthorized: boolean = false;
  opmUpdatesAvailable: boolean = false;
  visiblNoMatchesFoundPopup: boolean = false;
  totalCount: number;
  isPagingVisible: boolean = false;
  isDEV: boolean = false;
  isSTAGE: boolean = false;
  isQA: boolean = false;
  isLOAD: boolean = false;
  isLoadedgeo: boolean = false;
  renderselect: boolean = false;
  mfmodel: IMfModel = this.containermappingService.mfmodel;
  gname: string;
  baseMappingModel: IBaseMappingDetailGridDataModel = {
    BaseMappingDetails: [],
    TotalCount: 0
  };
  allbaseMappingModel: IBaseMappingDetailGridDataModel = {
    BaseMappingDetails: [],
    TotalCount: 0
  };
  isEnabled: Boolean;
  ngOnInit() {

    this.containermappingService.getCurrentUserAsync().then(() => {
      this.isUserAuthorized = true;
    },
      () => { // Required handle reject promise
      });

    //this.containermappingService.getNewOpmUpdatesAvailable().then((response) => {
    //  this.opmUpdatesAvailable = response;
    //});
    this.viewBaseMappings();

    this.containermappingService.getgeocodesBase().then((data) => {
      for (var k = 0; k < data.Geocode.length; k++) {
        this.geocode[k] = { id: k + 1, name: data.Geocode[k] }
      }
      this.isLoadedgeo = true;
    });
  }
  async viewBaseMappings() {
    this.filter.Geo = '';
    this.filter.Mfcode = '';
    this.currentPage = 0;
    this.page.CurrentPageNumber(0);
    this.gridtype.GridresultType(this.gridResultEnum.Basemapping);
    this.gridResult = this.gridtype.gridResult;
    await this.getBaseMappings();
    await this.getAllMapping();
  }
  loadMF($event) {
    if ($event.length != 0) {

      this.isLoadedmf = false;
      this.mfmodel.geo = $event[0].name.toString();
      this.mfmodel.envid = 5;
      this.containermappingService.getMfCodesBase(this.mfmodel).then((data) => {
        for (var j = 0; j < data.Mfcode.length; j++) {
          this.mfcode[j] = data.Mfcode[j];
        }
        this.mfcodeobs = of(this.mfcode);
      });
    }
    else {

      this.isLoadedmf = true;
      this.mfcode = [];
      this.mfcodeobs = of([]);
      this.ngselectmf.clearModel();

    }
  }
  isFormValid(): boolean {
    return !!(
      this.selectedgeo &&
      this.selectedgeo.length != 0);
  }

  async getValues() {

    this.geoname = [];
    for (var i = 0; i < this.selectedgeo.length; i++) {
      this.geoname.push(this.selectedgeo[i].name);
    }
    if (this.selectedmf.length != 0) {
      for (var i = 0; i < this.selectedmf.length; i++) {
        this.mfname.push(this.selectedmf[i]);
      }
    }
    this.filter.Geo = this.geoname.toString();
    this.filter.Mfcode = this.mfname.toString();
    this.geoname = [];
    this.mfname = [];
    this.currentPage = 0;
    this.page.CurrentPageNumber(0);
    this.gridtype.GridresultType(this.gridResultEnum.Basemapping);
    this.gridResult = this.gridtype.gridResult;
    await this.getBaseMappings();
    await this.getFilterBaseMappingDownloaded();
    this.isEnabled = true;
  }
  async getBaseMappings() {
    await this.containermappingService.getBasemappings(this.currentPage, false).then((data: IBaseMappingDetailGridDataModel) => {
      this.populateBaseMapping(data)
    })
  }
  async getAllMapping() {
    await this.containermappingService.getBasemappings(this.currentPage, true).then((data: IBaseMappingDetailGridDataModel) => {
      this.allbaseMappingModel = data;
    });
  }
  async getFilterBaseMappingDownloaded() {
    this.geoname = [];
    for (var i = 0; i < this.selectedgeo.length; i++) {
      this.geoname.push(this.selectedgeo[i].name);
    }
    if (this.selectedmf.length != 0) {
      for (var i = 0; i < this.selectedmf.length; i++) {
        this.mfname.push(this.selectedmf[i]);
      }
    }
    this.filter.Geo = this.geoname.toString();
    this.filter.Mfcode = this.mfname.toString();
    this.geoname = [];
    this.mfname = [];
    await this.containermappingService.getBasemappings(this.currentPage, true).then((data: IBaseMappingDetailGridDataModel) => {
      this.baseMappingModel = data;
    });
  }
  async refreshModel() {
    //if (!this.isFormValid()) { // Fix for IE, Edge
    //  return;
    //}
    await this.containermappingService.getBasemappings(this.currentPage, false).then((data: IBaseMappingDetailGridDataModel) => {

      this.gridDataModel = data;
      this.noMatchesFoundMsg = "No matches Found";
      this.visiblNoMatchesFoundPopup = data.BaseMappingDetails.length === 0;
      this.totalCount = data.TotalCount;
      this.isPagingVisible = data.BaseMappingDetails.length !== 0 && this.totalCount > Constants.PagingConst.RecordsPerPage;
    });
  }
  populateBaseMapping(data) {
    //if (!this.isFormValid()) { // Fix for IE, Edge
    //  return;
    //}    

    this.gridDataModel = data;
    this.noMatchesFoundMsg = "No matches Found";
    this.visiblNoMatchesFoundPopup = data.BaseMappingDetails.length === 0;
    this.totalCount = data.TotalCount;
    this.isPagingVisible = data.BaseMappingDetails.length !== 0 && this.totalCount > Constants.PagingConst.RecordsPerPage;
  }
  onPageChange(page: number) {
    this.currentPage = page;
    if (this.gridResult == this.gridTypeEnum.Basemapping) {
      this.getBaseMappings();
    }
    else {
      this.refreshModel();
    }
  }
  routeToContainerMapping() {
    this.router.navigate(['/containermappings/'], {
      skipLocationChange: true,
    });
  }
  async downloadExcel(fileData) {
    fileData = this.allbaseMappingModel.BaseMappingDetails;
    this.exportExcelService.excelfileCreationFromJson(fileData, `A&A People Feed BaseMapping_${new Date().toISOString().slice(0, 10)}.xlsx`, 'Base Mapping', true);
  }
}

